// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__VTAJa","blok-big-title":"Table_blok-big-title___5HrE","blok-title":"Table_blok-title___cCWj","blok-subtitle":"Table_blok-subtitle__6NWcz"};